import { Eye, Edit, Trash2 } from 'lucide-react';
import { CustomerContactListItem } from '../../../types/customer-contact';
import { formatAddress } from '../utils/contactHelpers';

export const CONTACT_COLUMNS = (
  loadingContact: boolean,
  onView: (contact: CustomerContactListItem) => void,
  onEdit: (contact: CustomerContactListItem) => void,
  onDelete: (contactId: number) => void,
) => [
  {
    id: 'name',
    label: 'Name',
    accessor: 'name',
    render: (c: CustomerContactListItem) => (
      <div className="flex items-center gap-1.5">
        <div className="font-medium text-sm theme-text-primary">{c.name}</div>
        {c.is_primary && (
          <span className="px-1.5 py-0.5 text-sm bg-blue-100 text-blue-800 rounded">Primary</span>
        )}
      </div>
    ),
  },
  {
    id: 'customer',
    label: 'Customer',
    accessor: 'customer',
    render: (c: CustomerContactListItem) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.customer?.item || '-'}</span>
    ),
  },
  {
    id: 'email',
    label: 'Email',
    accessor: 'email',
    render: (c: CustomerContactListItem) =>
      c.email ? (
        <a href={`mailto:${c.email}`} style={{ fontSize: 13, color: '#2563eb' }}>
          {c.email}
        </a>
      ) : (
        <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>-</span>
      ),
  },
  {
    id: 'phone',
    label: 'Phone',
    accessor: 'phone',
    render: (c: CustomerContactListItem) =>
      c.phone ? (
        <a href={`tel:${c.phone}`} style={{ fontSize: 13, color: '#2563eb' }}>
          {c.phone}
        </a>
      ) : (
        <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>-</span>
      ),
  },
  {
    id: 'title',
    label: 'Title',
    accessor: 'title',
    render: (c: CustomerContactListItem) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.title || '-'}</span>
    ),
  },
  {
    id: 'address',
    label: 'Address',
    accessor: 'address',
    render: (c: CustomerContactListItem) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{formatAddress(c)}</span>
    ),
  },
  {
    id: 'actions',
    label: 'Actions',
    accessor: 'id',
    render: (c: CustomerContactListItem) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          onClick={() => onView(c)}
          disabled={loadingContact}
          title="View Details"
          style={{ padding: '6px', color: '#2563eb', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(37,99,235,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Eye style={{ width: 16, height: 16 }} />
        </button>
        <button
          onClick={() => onEdit(c)}
          disabled={loadingContact}
          title="Edit"
          style={{ padding: '6px', color: '#7c3aed', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(124,58,237,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Edit style={{ width: 16, height: 16 }} />
        </button>
        <button
          onClick={() => onDelete(c.id)}
          title="Delete"
          style={{ padding: '6px', color: '#dc2626', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(220,38,38,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Trash2 style={{ width: 16, height: 16 }} />
        </button>
      </div>
    ),
  },
];
